module.exports = __webpack_public_path__ + "static/media/FoodPlot.svg";